import type { IconToken } from '@/styles/tokens'
import { cx } from '../cx'
import styles from './Icon.module.css'
import { type IconName, icons } from './icons'

export function Icon({
  name,
  size = 'icon-inline',
  label,
  className,
}: {
  name: IconName
  size?: IconToken
  label?: string
  className?: string
}) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="currentColor"
      focusable="false"
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
      className={cx(styles.icon, className)}
      data-size={size}
    >
      {icons[name].map((p) => (
        <path key={p.d} d={p.d} fillRule={p.fillRule} clipRule={p.clipRule} />
      ))}
    </svg>
  )
}
